<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
<!--        <preLoader v-if="loader"></preLoader>-->
        <div class="container">
            <div class="form-group" style="margin-top: 30px">
                <router-link :to="{path: '/role/create'}" class="btn btn-success">{{ $t('Add') }}</router-link>
            </div>

            <div class="panel panel-default ">
                <div class="panel-heading">لیست </div>
                <div class="panel-body  ">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>{{ $t('Name') }} {{ $t('role') }} </th>
                                    <th> {{ $t('Description') }}</th>
                                    <th>{{ $t('accesses') }} </th>
                                    <!--<th>وضعیت </th>-->

                                    <th width="100">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr id="items" v-for="(item, index) in items" :key="index">


                                    <td>{{ item.name}}</td>
                                    <td>{{ item.description}}</td>

                                    <td>
                                        <button type="button" class="btn btn-xs btn-info " data-toggle="modal" 
                                            :data-target="'#permissions-modal-'+item.id" @click="loaderMethod($event,item.id)">
                                            دسترسی های نقش
                                            </button>
                                        <div :id="'permissions-modal-'+item.id" class="modal fade" role="dialog">
                                            <div class="modal-dialog">

                                                <!-- Modal content-->
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <button type="button" class="close"
                                                            data-dismiss="modal">&times;{{ $t('accesses') }}</button>
                                                        <h4 class="modal-title"></h4>
                                                    </div>
                                                    <div class="modal-body">
                                                        <div v-for="(permission,index) in permission" :key="index"
                                                            style="margin:5px">
                                                            <input type="checkbox" class="option-input checkbox "
                                                                :value="permission.id"
                                                               >
                                                            <!--
                                                                 :checked="rolesHave(item.id, permission.id,index)"




                                                                    "
                                                                    @click="checkedRoles(role.id,$event)"
                                                                -->
                                                            {{  permission.display_name}}
                                                        </div>
                                                        <br>

                                                        <button :value="item.id"
                                                            v-on:click="updateRoles(item.id,$event)"
                                                            data-dismiss="modal" class="btn btn-success">
                                                            {{ $t('Update service') }}

                                                        </button>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-default"
                                                            data-dismiss="modal">{{ $t('Close') }}</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </td>



                                    <td>
                                        <!-- <router-link :to="{name: 'edit-rolesManager', params: {id: item.id}}"
                                            class="btn btn-xs btn-default">
                                            ویرایش
                                        </router-link> -->
                                        <a href="javascript: void(0)" class="btn btn-xs btn-danger"
                                            v-on:click="deleteEntry(item.id, index)">
                                            {{ $t('Delete') }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };

    export default {

        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                items: [],
                permission: [],
                checkedItem: [],
                loader: false,
                userlength: '',
                permissions:[]

            }
        },


        mounted() {
             this.loader=true
            axios
                .get('/admin-api/v1/role/list', this.auth)
                .then(response => {
                    this.items = response.data.data;
                    this.userlength = response.data.data.length
                    for (const key in response.data.data) {
                        if (response.data.data.hasOwnProperty(key)) {
                            const element = response.data.data[key];
                            // console.log(element.id)
                            this.userPermission(key, element.id)

                        }
                    }
                //    this.loader=false
                    console.log(this.items)
                    
                })
                .catch(error => {
                    this.loader = false
                    if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                        this.$snotify.warning('دسترسی شما برای این بخش محدود شده است');
                    } else {
                        this.$snotify.warning(error.response.data.message);
                    }

                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)
            axios
                .get('/admin-api/v1/permission/list', this.auth)
                .then(response => {
                    this.permission = response.data;
                    // console.log(response);
                    this.loader=false
                })
                .catch(error => {
                    this.loader = false
                    if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                        this.$snotify.warning('دسترسی شما برای این بخش محدود شده است');
                    } else {
                        this.$snotify.warning(error.response.data.message);
                    }

                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)
        }


        ,
        methods: {
            updateRoles(id, e) {

                var app = this;

                // let pesonId = e.target.value;
                app.checkedItem = []
                // //   this.chechedItem.services=[]
                e.target.parentElement.querySelectorAll('input').forEach(element => {
                    if (element.checked) {
                        app.checkedItem.push({
                            roles_id: element.value
                        })
                    }
                });
                console.log(app.checkedItem)
                axios
                    .post('/admin-api/v1/role/attach-permissions', {
                        id: id,
                        permissions: app.checkedItem
                    }, app.auth)
                    .then(response => {

                        console.log(response);

                    })
                    .catch(error => {
                        console.log(error.response);
                        app.errored = true
                    })
                    .finally(() => app.loading = false)


            },
            deleteEntry(id, index) {
                if (confirm("از حذف آیتم مطمئن هستید؟")) {
                    var app = this;
                    axios.get('/admin-api/v1/role/delete/' + id, app.auth)
                        .then(function (resp) {
                            app.$snotify.success('حذف با موفقیت انجام شد');
                            app.items.splice(index, 1);
                        })
                        .catch(function (resp) {
                            app.$snotify.warning("امکان حذف آیتم وجود ندارد");

                        });
                }
            },

            loaderMethod(e, userId) {
                 this.loader=true
                axios
                    .get(`/admin-api/v1/role/${userId}/permissions`, this.auth)
                    .then(response => {

                        this.permissions = response.data.data
                        console.log( this.permissions)
                         e.target.parentElement.querySelectorAll("input").forEach(element => {
                            if (this.permissions.find(x => x.id == element.value)) {
                                element.checked = true
                            } else {
                                element.checked = false
                            }

                        })
                         this.loader=false
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            }
            // getRelation(id) {
            //     axios.get('api/orders/' + id, this.auth)
            //         .then(function (resp) {
            //             console.log(resp.data.data.id);
            //             return resp.data.data.id;
            //         })
            //         .catch(function (resp) {
            //             return 'نا مشخص';
            //         });
            // }
        }
    }

</script>

